<template>
  <div class="section privacy-policy" style="text-align: left;">
    <div>
      <h1>English</h1>
      <h1>Privacy Policy</h1>
      <div class="paragraph">
        <h2>1. Privacy policy at a glance </h2>
        <div>
          <h3>General information</h3>
          <p>
            The following information provides a simple overview of what happens to your personal data when you visit this website.
            Personal data are all data with which you can be personally identified. You can find detailed information on the subject of data protection
            our data protection declaration listed below this text.
          </p>
        </div>

        <div>
          <h3>Data collection on this website </h3>
          <h4>Who is responsible for data collection on this website? </h4>
          <p>
            The data processing on this website is carried out by the website operator. You can find its contact details in the section &ldquo; Note on the responsible body &ldquo;
            in this data protection declaration.
          </p>
        </div>

        <div>
          <h4>How do we collect your data?</h4>
          <p>On the one hand, your data is collected when you provide it to us. This can be e.g. be data that you enter in a contact form.</p>
          <p>
            Other data is recorded automatically or with your consent when you visit the website by our hoster. This is mainly technical data
            (e.g. Internet browser, operating system or time of the page was viewed). This data is collected automatically as soon as you enter this website.
          </p>
        </div>

        <div>
          <h4>What do we use your data for? </h4>
          <p>Some of the data is collected in order to ensure that the website is error-free. Other data can be used to analyze your user behavior.</p>
        </div>

        <div>
          <h4>What rights do you have with regard to your data? </h4>
          <p>
            You have the right to receive information about the origin, recipient and purpose of your stored personal data free of charge at any time. You also have a right
            to request the correction or deletion of this data. If you have given your consent to data processing, you can revoke this consent at any time for the future.
            You also have the right, under certain circumstances, to request that the processing of your personal data be restricted.
            You also have the right to lodge a complaint with the responsible supervisory authority.
          </p>
          <p>You can contact us at any time if you have any further questions about data protection. </p>
        </div>

        <div>
          <h3>Analysis tools and tools from third-party providers </h3>
          <p>When you visit this website, your surfing behavior can be statistically evaluated. This is done primarily with so-called analysis programs.</p>
          <p>You can find detailed information on these analysis programs in the following data protection declaration. </p>
        </div>
      </div>

      <div class="paragraph">
        <h2>2. Hosting</h2>
        <div>
          <h3>External Hosting</h3>
          <p>
            This website is hosted by an external service provider (hoster). The personal data recorded on this website are stored on the host's servers.
            This can be v. a. be IP addresses, contact requests, meta and communication data, contract data, contact data, names, website access and other data generated via a website.
          </p>
          <p>
            The hoster is used for the purpose of fulfilling the contract with our potential and existing customers (Art. 6 Para. 1 lit. b GDPR) and in the interest of a secure,
            fast and efficient provision of our online offer by a professional provider (Art. 6 Para. 1 lit. f GDPR).
          </p>
          <p>Our host will only process your data insofar as this is necessary to fulfill its performance obligations and follow our instructions with regard to this data. </p>
          <p>We use the following hoster: </p>
          <p>Netlify, Inc.,<br />
            2325 3rd Street,<br />
            Suite 296,<br />
            San Francisco,<br />
            California 94107</p>
        </div>
      </div>

      <div class="paragraph">
        <h2>3. General information and mandatory information </h2>
        <div>
          <h3>Data protecion</h3>
          <p>The operators of this website take the protection of your personal data very seriously. We treat your personal data confidentially and in accordance with the statutory data protection regulations and this data protection declaration. </p>
          <p>
            When you use this website, various personal data are collected. Personal data are data with which you can be personally identified.
            This data protection declaration explains what data we collect and what we use it for. It also explains how and for what purpose this happens.
          </p>
          <p>
            We would like to point out that data transmission over the Internet (e.g. when communicating by e-mail) can have security gaps. A complete protection of the data
            Access by third parties is not possible.
          </p>
        </div>

        <div>
          <h3>Note on the responsible body</h3>
          <p>The responsible body is the natural or legal person who, alone or jointly with others, decides on the purposes and means of processing personal data (e.g. names, email addresses, etc.) . </p>
        </div>

        <div>
          <h3>Storage period </h3>
          <p>
            Unless a specific storage period is specified in this data protection declaration, your personal data will remain with us until the purpose for the data processing no longer applies.
            If you assert a legitimate deletion request or revoke your consent to data processing, your data will be deleted, unless we provide other legally permissible reasons
            have your personal data stored (e.g. tax or commercial retention periods); in the latter case, the deletion takes place after these reasons no longer apply.
          </p>
        </div>

        <div>
          <h3>Note on data transfer to the USA and other third countries </h3>
          <p>
            Among other things, we use tools from companies based in the USA or other third countries that are not secure in terms of data protection law. When these tools are active, your personal
            Data is transferred to these third countries and processed there. We would like to point out that in these countries no data protection level comparable to that in the EU can be guaranteed. For example are
            US companies are obliged to surrender personal data to security authorities without you as the person concerned being able to take legal action against this. It cannot therefore be ruled out
            We will ensure that US authorities (e.g. secret services) process, evaluate and permanently store your data on US servers for monitoring purposes. We got on this
            Processing activities have no influence.
          </p>
        </div>

        <div>
          <h3>Revocation of your consent to data processing</h3>
          <p>
            Many data processing operations are only possible with your express consent. You can revoke your consent at any time. The legality
            the data processing carried out up to the point of revocation remains unaffected by the revocation.
          </p>
        </div>

        <div>
          <h3>Right to object to data collection in special cases and to direct mail (Art. 21 GDPR) </h3>
          <p>
            IF THE DATA PROCESSING BASED ON ART. 6 ABS. 1 LIT. E OR F GDPR, YOU HAVE THE RIGHT AT ANY TIME, FOR REASONS ARISING FROM YOUR SPECIAL SITUATION,
            TO OBJECT TO THE PROCESSING OF YOUR PERSONAL DATA; THIS ALSO APPLIES TO PROFILING BASED ON THESE PROVISIONS. THE RELEVANT LEGAL BASIS,
            ON WHICH PROCESSING IS BASED, TAKE THIS PRIVACY POLICY. IF YOU OBJECT, WE WILL NO LONGER PROCESS YOUR AFFECTED PERSONAL DATA,
            UNLESS WE CAN PROVE MANDATORY PROTECTIVE REASONS FOR THE PROCESSING THAT WEIGH YOUR INTERESTS, RIGHTS AND FREEDOMS OR THE PROCESSING
            FOR THE ASSISTANCE, EXERCISE OR DEFENSE OF LEGAL CLAIMS (OBJECTION ACCORDING TO ART. 21 PARA. 1 GDPR).
          </p>
          <p>
            IF YOUR PERSONAL DATA IS PROCESSED IN ORDER TO OPERATE DIRECT ADVERTISING, YOU HAVE THE RIGHT TO OBJECT AT ANY TIME TO THE PROCESSING OF PERSONAL DATA CONCERNING YOU
            SUBMIT FOR SUCH ADVERTISEMENT; THIS ALSO APPLIES TO PROFILING TO THE EXTENT IN CONNECTION WITH SUCH DIRECT ADVERTISING. IF YOU DISAGREE, YOU WILL BECOME PERSONAL
            THEN DATA NO LONGER USED FOR THE PURPOSES OF DIRECT ADVERTISING (OBJECTION ACCORDING TO ART. 21 PARA. 2 GDPR).
          </p>
        </div>

        <div>
          <h3>Right of appeal to the responsible supervisory authority </h3>
          <p>
            In the event of violations of the GDPR, the data subjects have the right to lodge a complaint with a supervisory authority, in particular in the member state of their habitual residence.
            their place of work or the location of the suspected infringement. The right of appeal exists without prejudice to other administrative or judicial remedies.
          </p>
        </div>

        <div>
          <h3>Right to data portability </h3>
          <p>
            You have the right to transfer data that we process automatically on the basis of your consent or in fulfillment of a contract to yourself or to a third party in a common,
            to hand over the machine-readable format. If you request the direct transfer of the data to another person responsible, this will only be done to the extent that it is technically possible
            is feasible.
          </p>
        </div>

        <div>
          <h3>SSL or TLS encryption </h3>
          <p>
            This site is used for security reasons and to protect the transmission of confidential content, such as orders or inquiries that you send to us as the site operator
            send, an SSL or TLS encryption. You can recognize an encrypted connection by the fact that the address line of the browser changes from &ldquo; http: // &ldquo; on &ldquo; https: // &ldquo;
            changes and the lock symbol in your browser line.
          </p>
          <p>
            If the SSL or TLS encryption is activated, the data that you transmit to us cannot be read by third parties.
          </p>
        </div>

        <div>
          <h3>Information, deletion and correction </h3>
          <p>
            Within the framework of the applicable legal provisions, you have the right to free information about your stored personal data, their origin and recipient at any time
            and the purpose of the data processing and, if necessary, a right to correct or delete this data. You can contact us at any time for this and other questions on the subject of personal data
            contact us.
          </p>
        </div>

        <div>
          <h3>Right to restriction of processing</h3>
          <p>
            You have the right to request that the processing of your personal data be restricted. You can contact us at any time for this purpose. The right to restrict the
            Processing consists in the following cases:
          </p>
          <ul>
            <li>
              If you dispute the accuracy of your personal data stored by us, we usually need time to check this. For the duration of the
              You have the right to request the restriction of the processing of your personal data.
            </li>
            <li>If the processing of your personal data happened / happens unlawfully, you can request the restriction of the data processing instead of the deletion. </li>
            <li>
              If we no longer need your personal data, but you need them to exercise, defend or assert legal claims, you have the right to
              to request the restriction of the processing of your personal data instead of the deletion.
            </li>
            <li>
              If you have lodged an objection according to Art. 21 Paragraph 1 GDPR, a balance must be made between your and our interests. As long as it is not yet clear whose
              If interests prevail, you have the right to request that the processing of your personal data be restricted.
            </li>
          </ul>
          <p>
            If you have restricted the processing of your personal data, this data may - apart from their storage &ndash; only with your consent or for
            Assertion, exercise or defense of legal claims or to protect the rights of another natural or legal person or for reasons of an important one
            in the public interest of the European Union or a member state.
          </p>
        </div>
      </div>

      <div class="paragraph">
        <h2>4. Data collection on this website </h2>
        <div>
          <h3>Cookies</h3>
          <p>
            Our Internet pages use so-called "cookies". Cookies are small text files and do not cause any damage to your device. They are either temporary
            Stored for the duration of a session (session cookies) or permanently (permanent cookies) on your device. Session cookies are automatically deleted after your visit.
            Permanent cookies remain stored on your device until you delete them yourself or until your web browser automatically deletes them.
          </p>
          <p>
            In some cases, cookies from third-party companies can also be stored on your device when you enter our site (third-party cookies). These allow us or
            You use certain services of the third party (e.g. cookies for processing payment services).
          </p>
          <p>
            Cookies haben verschiedene Funktionen. Zahlreiche Cookies sind technisch notwendig, da bestimmte Websitefunktionen ohne diese nicht funktionieren w&uuml;rden (z.&nbsp;B. die Warenkorbfunktion
            oder die Anzeige von Videos). Andere Cookies dienen dazu, das Nutzerverhalten auszuwerten&nbsp;oder Werbung anzuzeigen.
          </p>
          <p>
            Cookies that are used to carry out the electronic communication process (necessary cookies) or to provide certain functions that you have requested (functional cookies,
            E.g. &nbsp; B. for the shopping cart function) or to optimize the website (e.g. cookies to measure the web audience) are required on the basis of Art. 6 Para. 1 lit.f GDPR
            saved, unless another legal basis is given. The website operator has a legitimate interest in storing cookies for technically error-free and optimized provision
            of his services. If consent to the storage of cookies has been requested, the relevant cookies are saved exclusively on the basis of this consent
            (Art. 6 Para. 1 lit. a GDPR); the consent can be withdrawn at any time.
          </p>
          <p>
            You can set your browser so that you are informed about the setting of cookies and only allow cookies in individual cases, the acceptance of cookies for certain
            Cases or generally exclude and activate the automatic deletion of cookies when you close the browser. When deactivating cookies, the functionality
            this website may be restricted.
          </p>
          <p>
            Insofar as cookies are used by third-party companies or for analysis purposes, we will inform you about this separately in the context of this data protection declaration
            inform and, if necessary, ask for consent.
          </p>
        </div>

        <div>
          <h3>Inquiries by email, phone or fax</h3>
          <p>
            If you contact us by e-mail, telephone or fax, your request, including all personal data derived from it (name, request), will be processed by us for the purpose of processing your request
            stored and processed. We do not pass on this data without your consent.
          </p>
          <p>
            The processing of this data takes place on the basis of Art. 6 Paragraph 1 lit. b GDPR, provided that your request is related to the performance of a contract or for the execution of a pre-contractual one
            Action is required. In all other cases, the processing is based on our legitimate interest in the effective processing of the inquiries sent to us
            (Art. 6 Para. 1 lit. f GDPR) or on your consent (Art. 6 Para. 1 lit. a GDPR) if this has been requested.
          </p>
          <p>
            The data you send to us via contact requests will remain with us until you ask us to delete it, revoke your consent to storage or the purpose
            Does not apply to data storage (e.g. after your request has been processed). Mandatory legal provisions &ndash; in particular statutory retention periods
            - remain untouched.
          </p>
        </div>
      </div>

      <div class="paragraph">
        <h2>5. Plugins & Tools</h2>
        <div>
          <h3>Google Web Fonts</h3>
          <p>
            This page uses so-called web fonts, which are provided by Google, for the uniform display of fonts. When you call up a page, your browser loads the required information
            Web fonts in your browser cache to display texts and fonts correctly.
          </p>
          <p>
            For this purpose, the browser you are using must connect to the Google servers. This gives Google knowledge that your IP address has been used to
            Website was accessed. The use of Google WebFonts is based on Art. 6 Para. 1 lit. f GDPR. The website operator has a legitimate interest in the uniform representation of the typeface
            on his website. If a corresponding consent has been requested (e.g. consent to the storage of cookies), processing takes place exclusively on the basis of Art. 6 Para. 1 lit. a GDPR;
            the consent can be withdrawn at any time.
          </p>
          <p>If your browser does not support web fonts, a standard font will be used by your computer. </p>
          <p>For more information on Google Web Fonts, see
            <a href="https://developers.google.com/fonts/faq" target="_blank" rel="noopener noreferrer">https://developers.google.com/fonts/faq</a>
            and in Google's privacy policy:
            <a href="https://policies.google.com/privacy?hl=de" target="_blank" rel="noopener noreferrer">https://policies.google.com/privacy?hl=de</a>.
          </p>
          <p>Source: <a href="https://www.e-recht24.de">https://www.e-recht24.de</a></p>
        </div>
        <div>
          <h3>Google Analytics</h3>
          <p>We use Google Analytics to analyze website usage. The data obtained from this is used to optimize our website. &nbsp;</p>
          <p>
            Google Analytics is a web analysis service operated and provided by <em> Google Inc. </em> (1600 Amphitheater Parkway, Mountain View, CA 94043, United States).
            Google processes the website usage data on our behalf and is contractually obliged to take measures to guarantee the confidentiality of the processed data.
          </p>
          <p>The following data, among other things, are recorded during your visit to the website: </p>
          <ul>
            <li>Pages accessed </li>
            <li>Your behavior on the pages (e.g. clicks, scrolling behavior and length of stay) </li>
            <li>Your approximate location (country and city) </li>
            <li>Your anonymized IP address (in abbreviated form so that no clear assignment is possible) </li>
            <li>Technical information such as browser, internet provider, device and screen resolution </li>
            <li>Source of origin of your visit (i.e. via which website you came to us) </li>
          </ul>

          <p>This data is transmitted to a Google server in the USA. &nbsp;</p>
          <p>
            Google Analytics speichert Cookies in Ihrem Webbrowser für die Dauer von zwei&nbsp;Jahren seit Ihrem letzten Besuch. Diese Cookies enthalten eine zufallsgenerierte User-ID, mit der
            Sie bei zukünftigen Website-Besuchen wiedererkannt werden können.
          </p>
          <p>
            The recorded data is saved together with the randomly generated user ID, which enables pseudonymous user profiles to be evaluated. These user-related data are
            automatically deleted after 2 months. Other data are stored indefinitely in aggregated form.
          </p>
          <p>
            If you do not agree to the recording, you can do this with the one-time installation of the
            <a href="https://tools.google.com/dlpage/gaoptout?hl=de">Browser add-ons to deactivate Google Analytics </a> or
            by rejecting cookies via our cookie settings dialog.
          </p>
          <p>The following cookies are used by Google Analytics: </p>
          <ul>
            <li>
              _ga_#
              <p>Scope: your domain (1st party) </p>
              <p>Purpose: Contains a randomly generated user ID. Using this ID, Google Analytics can recognize returning users on this website and merge the data from previous visits. </p>
              <p>Storage period: 2 years </p>
            </li>
            <li>
              _ga
              <p>Scope: your domain (1st party) </p>
              <p>Purpose: Contains a randomly generated user ID. Using this ID, Google Analytics can recognize returning users on this website and merge the data from previous visits.</p>
              <p>Storage period: 2 years</p>
            </li>
          </ul>
          <p><em>Source: <a href="https://traffic3.net/">traffic3.net</a></em></p>
        </div>
        <div>
          <h3>Cookiebot</h3>
          Affected: Website visitors <br />
          Purpose: Obtaining consent to certain cookies and thus the use of certain tools <br />
          Processed data: Data for managing the cookie settings such as IP address, time of consent, type of consent, individual consents. You can find more details on this with the tool used in each case. <br />
          Storage period: the data will be deleted after one year <br />
          Legal basis: Article 6 (1) (a) GDPR (consent), Article 6 (1) (f) GDPR (legitimate interests)
        </div>
        <div>
          <h3>What is Cookiebot?</h3>
          <p>We use functions of the provider Cookiebot on our website. The company behind Cookiebot is Cybot A / S, Havnegade 39, 1058 Copenhagen, DK. Among other things, Cookiebot allows us to provide you with a comprehensive cookie notice (also known as a cookie banner or cookie notice). By using this function, your data can be sent to Cookiebot or Cybot, saved and processed. In this data protection declaration we inform you why we use Cookiebot, which data is transferred and how you can prevent this data transfer. </p>
          <p>Cookiebot is a software product from Cybot. The software automatically creates a GDPR-compliant cookie notice for our website visitors. In addition, the technology behind Cookiebot scans, controls and evaluates all cookies and tracking measures on our website. </p>
          <div>
            <h3>Why do we use Cookiebot on our website? </h3>
            <p>We take data protection very seriously. We want to show you exactly what is going on on our website and which of your data is stored. Cookiebot helps us to get a good overview of all our cookies (first and third party cookies). In this way we can inform you precisely and transparently about the use of cookies on our website. You will always receive an up-to-date and data protection-compliant cookie notice and decide for yourself which cookies you allow and which you do not. </p>
          </div>
          <div>
            <h3>What data does Cookiebot save? </h3>
            <p>If you allow cookies, the following data will be transmitted to Cybot, saved and processed. </p>
            <ul>
              <li>IP address (in anonymous form, the last 3 digits are set to 0) </li>
              <li>Date and time of your consent </li>
              <li>our Website-URL</li>
              <li>technical browser data </li>
              <li>encrypted, anonymous key </li>
              <li>the cookies you have allowed (as proof of consent) </li>
            </ul>
            <p>The following cookies are set by Cookiebot if you have consented to the use of cookies: </p>
            <p>
              <strong>Name:</strong> CookieConsent<br />
              <strong>Value:</strong> {stamp:&#8217;P7to4eNgIHvJvDerjKneBsmJQd9311895308-2<br />
              <strong>Purpose:</strong> Your consent status is saved in this cookie. This means that our website can also read and follow the current status on future visits. <br />
              <strong>Expiry Date::</strong> after one year
            </p>
            <p>
              <strong>Name:</strong> CookieConsentBulkTicket<br />
              <strong>Value:</strong> kDSPWpA%2fjhljZKClPqsncfR8SveTnNWhys5NojaxdFYBPjZ2PaDnUw%3d%3311895308-6<br />
              <strong>Purpose:</strong> This cookie is set if you allow all cookies and thus a &#8220; collective consent &#8221; have activated. The cookie then saves its own, random and unique ID. <br />
              <strong>Expiry Date: </strong>after one year
            </p>
            <p>
              <strong>Name:</strong> _abck<br />
              <strong>Value:</strong> DA365EC9CD1866BD195632D505CA6D0C~21QQyocU/0HSrmpVzVzoNNHU+XackLuiAKp6kmFzsd5Xc+35eNu3iyapLXcmwMCTR+621W1OImZkn4w/lszcbbw3Iiavmj304rMGnQWVr0r/r52bNvgOyz81wg85LeRJym7p89hW4QgRwdvxE2YFJZpNZA1zOmK1aY2LKaHIzNs=<br />
              <strong>Purpose:</strong> Used to detect and ward off replay cookie attacks - the cookie is necessary for the security and integrity of the website. <br />
              <strong>Expiry Date: </strong>after one year
            </p>
            <p>
              <strong>Name:</strong> bm_sv<br />
              <strong>Value:</strong> C5D97903D3B2B8E09D98C38C9445EB7C~0~YAAQB9R7XE9afEh9AQAAKYH5kQdxFUSqWKabJG5n4VSabx3aGU51Yhp2swydWTv3T/bPjQNnrIc04G0qIuyBtDw2Vr4nGqJFRMPQCQ9vqLA7TZdcXtncrVVUC+x0Iriamc6imB37zWbmROhbUTHs1avGmOCCDP3i8+7GNvB9TS8/E1xkMGVhGZBE13dF6sPfTEUnAmvq7nuymr+Dx9BTtwSo50ebC5E3nzdmx4WIVvFeXFqJAFgjb9N+hSnDx54h6IuVg/B6mUMZ1FKAc=~-1~-1~-1<br />
              <strong>Purpose:</strong> This cookie is used to differentiate between humans and bots. This is beneficial for the website to generate valid reports on the use of its website. <br />
              <strong>Expiry Date: </strong>after one day
            </p>
            <p>
              According to Cybot's privacy policy, the company does not sell personal information. However, Cybot passes on data to trustworthy third parties or subcontractors,
              which help the company to achieve its own business goals. Data will also be passed on if this is legally required.
            </p>
          </div>
          <div>
            <h3>How long and where will the data be stored? </h3>
            <p>
              All data collected will only be transmitted, stored and forwarded within the European Union. The data is in an Azure data center
              (Cloud provider is Microsoft). On 
              <a class="adsimple-311895308" href="https://azure.microsoft.com/de-de/global-infrastructure/regions/?tid=311895308" target="_blank" rel="noopener noreferrer">https://azure.microsoft.com/de-de/global-infrastructure/regions/</a>
              you can learn more about all "Azure regions". All user data will be deleted by Cookiebot after 12 months from registration (cookie consent) or immediately after termination of the Cookiebot service.
            </p>
          </div>
          <div>
            <h3>How can I delete my data or prevent data storage? </h3>
            <p>
              You have the right to access your personal data at any time and also to delete it. You can prevent data collection and storage, for example, by clicking the cookie notice
              refuse the use of cookies. Your browser offers another possibility to prevent data processing or to manage it according to your wishes. Depending on the browser, this works
              Cookie management a little different. Here you will find the instructions for the most popular browsers at the moment:
            </p>
            <p>
              <a href="https://support.google.com/chrome/answer/95647?tid=311895308" target="_blank" rel="noopener noreferrer">Chrome: Delete, activate and manage cookies in Chrome </a>
            </p>
            <p>
              <a href="https://support.apple.com/de-at/guide/safari/sfri11471/mac?tid=311895308" target="_blank" rel="noopener noreferrer">Safari: manage cookies and website data with Safari </a>
            </p>
            <p>
              <a href="https://support.mozilla.org/de/kb/cookies-und-website-daten-in-firefox-loschen?tid=311895308" target="_blank" rel="noopener noreferrer">Firefox: Delete cookies to remove data that websites have stored on your computer </a>
            </p>
            <p>
              <a href="https://support.microsoft.com/de-at/help/17442/windows-internet-explorer-delete-manage-cookies?tid=311895308" target="_blank" rel="noopener noreferrer">Internet Explorer: deleting and managing cookies </a>
            </p>
            <p>
              <a href="https://support.microsoft.com/de-at/help/4027947/windows-delete-cookies?tid=311895308" target="_blank" rel="noopener noreferrer">Microsoft Edge: Deleting and managing cookies </a>
            </p>
          </div>
          <div>
            <h3>Legal basis </h3>
            <p>
              If you agree to cookies, your personal data will be processed and saved via these cookies. If we are allowed to use cookies with your <strong> consent </strong> (Article 6 Para. 1 lit. a GDPR),
              this consent is also the legal basis for the use of cookies and the processing of your data. In order to be able to manage the consent to cookies and to enable you to give your consent,
              the Cookiebot is used. The use of this software enables us to operate the website in an efficient and legally compliant manner, which is a <strong> legitimate interest </strong> (Article 6 Paragraph 1 lit.f GDPR).
            </p>
            <p>If you want to find out more about the data protection guidelines of "Cookiebot" or the company behind it, Cybot, we recommend that you read the data protection guidelines at this link.  <a class="adsimple-311895308" href="https://www.cookiebot.com/de/privacy-policy/?tid=311895308" target="_blank" rel="noopener noreferrer">https://www.cookiebot.com/de/privacy-policy/</a></p>
            <p>&nbsp;</p>
            <p>All texts are copyrighted. </p>
            <p>Source: Created with the <a href="https://www.adsimple.de/datenschutz-generator/" title="Datenschutz Generator von AdSimple für Deutschland">Datenschutz Generator</a> from AdSimple</p>
          </div>
        </div>
      </div>
    </div>
    <div>
      <h1>German</h1>
      <h1>Datenschutz&shy;erkl&auml;rung</h1>
      <div class="paragraph">
        <h2>1. Datenschutz auf einen Blick</h2>
        <div>
          <h3>Allgemeine Hinweise</h3>
          <p>
            Die folgenden Hinweise geben einen einfachen &Uuml;berblick dar&uuml;ber, was mit Ihren personenbezogenen Daten passiert, wenn Sie diese Website besuchen.
            Personenbezogene Daten sind alle Daten, mit denen Sie pers&ouml;nlich identifiziert werden k&ouml;nnen. Ausf&uuml;hrliche Informationen zum Thema Datenschutz entnehmen Sie
            unserer unter diesem Text aufgef&uuml;hrten Datenschutzerkl&auml;rung.
          </p>
        </div>

        <div>
          <h3>Datenerfassung auf dieser Website</h3>
          <h4>Wer ist verantwortlich f&uuml;r die Datenerfassung auf dieser Website?</h4>
          <p>
            Die Datenverarbeitung auf dieser Website erfolgt durch den Websitebetreiber. Dessen Kontaktdaten k&ouml;nnen Sie dem Abschnitt &bdquo;Hinweis zur Verantwortlichen Stelle&ldquo;
            in dieser Datenschutzerkl&auml;rung entnehmen.
          </p>
        </div>

        <div>
          <h4>Wie erfassen wir Ihre Daten?</h4>
          <p>Ihre Daten werden zum einen dadurch erhoben, dass Sie uns diese mitteilen. Hierbei kann es sich z.&nbsp;B. um Daten handeln, die Sie in ein Kontaktformular eingeben.</p>
          <p>
            Andere Daten werden automatisch oder nach Ihrer Einwilligung beim Besuch der Website durch unseren Hoster erfasst. Das sind vor allem technische Daten
            (z.&nbsp;B. Internetbrowser, Betriebssystem oder Uhrzeit des Seitenaufrufs). Die Erfassung dieser Daten erfolgt automatisch, sobald Sie diese Website betreten.
          </p>
        </div>

        <div>
          <h4>Wof&uuml;r nutzen wir Ihre Daten?</h4>
          <p>Ein Teil der Daten wird erhoben, um eine fehlerfreie Bereitstellung der Website zu gew&auml;hrleisten. Andere Daten k&ouml;nnen zur Analyse Ihres Nutzerverhaltens verwendet werden.</p>
        </div>

        <div>
          <h4>Welche Rechte haben Sie bez&uuml;glich Ihrer Daten?</h4>
          <p>
            Sie haben jederzeit das Recht, unentgeltlich Auskunft &uuml;ber Herkunft, Empf&auml;nger und Zweck Ihrer gespeicherten personenbezogenen Daten zu erhalten. Sie haben au&szlig;erdem ein Recht,
            die Berichtigung oder L&ouml;schung dieser Daten zu verlangen. Wenn Sie eine Einwilligung zur Datenverarbeitung erteilt haben, k&ouml;nnen Sie diese Einwilligung jederzeit f&uuml;r die Zukunft widerrufen.
            Au&szlig;erdem haben Sie das Recht, unter bestimmten Umst&auml;nden die Einschr&auml;nkung der Verarbeitung Ihrer personenbezogenen Daten zu verlangen.
            Des Weiteren steht Ihnen ein Beschwerderecht bei der zust&auml;ndigen Aufsichtsbeh&ouml;rde zu.
          </p>
          <p>Hierzu sowie zu weiteren Fragen zum Thema Datenschutz k&ouml;nnen Sie sich jederzeit an uns wenden.</p>
        </div>

        <div>
          <h3>Analyse-Tools und Tools von Dritt&shy;anbietern</h3>
          <p>Beim Besuch dieser Website kann Ihr Surf-Verhalten statistisch ausgewertet werden. Das geschieht vor allem mit sogenannten Analyseprogrammen.</p>
          <p>Detaillierte Informationen zu diesen Analyseprogrammen finden Sie in der folgenden Datenschutzerkl&auml;rung.</p>
        </div>
      </div>

      <div class="paragraph">
        <h2>2. Hosting</h2>
        <div>
          <h3>Externes Hosting</h3>
          <p>
            Diese Website wird bei einem externen Dienstleister gehostet (Hoster). Die personenbezogenen Daten, die auf dieser Website erfasst werden, werden auf den Servern des Hosters gespeichert.
            Hierbei kann es sich v. a. um IP-Adressen, Kontaktanfragen, Meta- und Kommunikationsdaten, Vertragsdaten, Kontaktdaten, Namen, Websitezugriffe und sonstige Daten, die &uuml;ber eine Website generiert werden, handeln.
          </p>
          <p>
            Der Einsatz des Hosters erfolgt zum Zwecke der Vertragserf&uuml;llung gegen&uuml;ber unseren potenziellen und bestehenden Kunden (Art. 6 Abs. 1 lit. b DSGVO) und im Interesse einer sicheren,
            schnellen und effizienten Bereitstellung unseres Online-Angebots durch einen professionellen Anbieter (Art. 6 Abs. 1 lit. f DSGVO).
          </p>
          <p>Unser Hoster wird Ihre Daten nur insoweit verarbeiten, wie dies zur Erf&uuml;llung seiner Leistungspflichten erforderlich ist und unsere Weisungen in Bezug auf diese Daten befolgen.</p>
          <p>Wir setzen folgenden Hoster ein:</p>
          <p>Netlify, Inc.,<br />
            2325 3rd Street,<br />
            Suite 296,<br />
            San Francisco,<br />
            California 94107</p>
        </div>
      </div>

      <div class="paragraph">
        <h2>3. Allgemeine Hinweise und Pflicht&shy;informationen</h2>
        <div>
          <h3>Datenschutz</h3>
          <p>Die Betreiber dieser Seiten nehmen den Schutz Ihrer pers&ouml;nlichen Daten sehr ernst. Wir behandeln Ihre personenbezogenen Daten vertraulich und entsprechend den gesetzlichen Datenschutzvorschriften sowie  dieser Datenschutzerkl&auml;rung.</p>
          <p>
            Wenn Sie diese Website benutzen, werden verschiedene personenbezogene Daten erhoben. Personenbezogene Daten sind Daten, mit denen Sie pers&ouml;nlich identifiziert werden k&ouml;nnen.
            Die vorliegende Datenschutzerkl&auml;rung erl&auml;utert, welche Daten wir erheben und wof&uuml;r wir sie nutzen. Sie erl&auml;utert auch, wie und zu welchem Zweck das geschieht.
          </p>
          <p>
            Wir weisen darauf hin, dass die Daten&uuml;bertragung im Internet (z.&nbsp;B. bei der Kommunikation per E-Mail) Sicherheitsl&uuml;cken aufweisen kann. Ein l&uuml;ckenloser Schutz der Daten vor
            dem Zugriff durch Dritte ist nicht m&ouml;glich.
          </p>
        </div>

        <div>
          <h3>Hinweis zur verantwortlichen Stelle</h3>
          <p>Verantwortliche Stelle ist die nat&uuml;rliche oder juristische Person, die allein oder gemeinsam mit anderen &uuml;ber die Zwecke und Mittel der Verarbeitung von personenbezogenen Daten (z.&nbsp;B. Namen, E-Mail-Adressen o. &Auml;.) entscheidet.</p>
        </div>

        <div>
          <h3>Speicherdauer</h3>
          <p>
            Soweit innerhalb dieser Datenschutzerkl&auml;rung keine speziellere Speicherdauer genannt wurde, verbleiben Ihre personenbezogenen Daten bei uns, bis der Zweck f&uuml;r die Datenverarbeitung entf&auml;llt.
            Wenn Sie ein berechtigtes L&ouml;schersuchen geltend machen oder eine Einwilligung zur Datenverarbeitung widerrufen, werden Ihre Daten gel&ouml;scht, sofern wir keine anderen rechtlich zul&auml;ssigen Gr&uuml;nde f&uuml;r
            die Speicherung Ihrer personenbezogenen Daten haben (z.&nbsp;B. steuer- oder handelsrechtliche Aufbewahrungsfristen); im letztgenannten Fall erfolgt die L&ouml;schung nach Fortfall dieser Gr&uuml;nde.
          </p>
        </div>

        <div>
          <h3>Hinweis zur Datenweitergabe in die USA und sonstige Drittstaaten</h3>
          <p>
            Wir verwenden unter anderem Tools von Unternehmen mit Sitz in den USA oder sonstigen datenschutzrechtlich nicht sicheren Drittstaaten. Wenn diese Tools aktiv sind, k&ouml;nnen Ihre personenbezogene
            Daten in diese Drittstaaten &uuml;bertragen und dort verarbeitet werden. Wir weisen darauf hin, dass in diesen L&auml;ndern kein mit der EU vergleichbares Datenschutzniveau garantiert werden kann. Beispielsweise sind
            US-Unternehmen dazu verpflichtet, personenbezogene Daten an Sicherheitsbeh&ouml;rden herauszugeben, ohne dass Sie als Betroffener hiergegen gerichtlich vorgehen k&ouml;nnten. Es kann daher nicht ausgeschlossen
            werden, dass US-Beh&ouml;rden (z.&nbsp;B. Geheimdienste) Ihre auf US-Servern befindlichen Daten zu &Uuml;berwachungszwecken verarbeiten, auswerten und dauerhaft speichern. Wir haben auf diese
            Verarbeitungst&auml;tigkeiten keinen Einfluss.
          </p>
        </div>

        <div>
          <h3>Widerruf Ihrer Einwilligung zur Datenverarbeitung</h3>
          <p>
            Viele Datenverarbeitungsvorg&auml;nge sind nur mit Ihrer ausdr&uuml;cklichen Einwilligung m&ouml;glich. Sie k&ouml;nnen eine bereits erteilte Einwilligung jederzeit widerrufen. Die Rechtm&auml;&szlig;igkeit
            der bis zum Widerruf erfolgten Datenverarbeitung bleibt vom Widerruf unber&uuml;hrt.
          </p>
        </div>

        <div>
          <h3>Widerspruchsrecht gegen die Datenerhebung in besonderen F&auml;llen sowie gegen Direktwerbung (Art. 21 DSGVO)</h3>
          <p>
            WENN DIE DATENVERARBEITUNG AUF GRUNDLAGE VON ART. 6 ABS. 1 LIT. E ODER F DSGVO ERFOLGT, HABEN SIE JEDERZEIT DAS RECHT, AUS GR&Uuml;NDEN, DIE SICH AUS IHRER BESONDEREN SITUATION ERGEBEN,
            GEGEN DIE VERARBEITUNG IHRER PERSONENBEZOGENEN DATEN WIDERSPRUCH EINZULEGEN; DIES GILT AUCH F&Uuml;R EIN AUF DIESE BESTIMMUNGEN GEST&Uuml;TZTES PROFILING. DIE JEWEILIGE RECHTSGRUNDLAGE,
            AUF DENEN EINE VERARBEITUNG BERUHT, ENTNEHMEN SIE DIESER DATENSCHUTZERKL&Auml;RUNG. WENN SIE WIDERSPRUCH EINLEGEN, WERDEN WIR IHRE BETROFFENEN PERSONENBEZOGENEN DATEN NICHT MEHR VERARBEITEN,
            ES SEI DENN, WIR K&Ouml;NNEN ZWINGENDE SCHUTZW&Uuml;RDIGE GR&Uuml;NDE F&Uuml;R DIE VERARBEITUNG NACHWEISEN, DIE IHRE INTERESSEN, RECHTE UND FREIHEITEN &Uuml;BERWIEGEN ODER DIE VERARBEITUNG
            DIENT DER GELTENDMACHUNG, AUS&Uuml;BUNG ODER VERTEIDIGUNG VON RECHTSANSPR&Uuml;CHEN (WIDERSPRUCH NACH ART. 21 ABS. 1 DSGVO).
          </p>
          <p>
            WERDEN IHRE PERSONENBEZOGENEN DATEN VERARBEITET, UM DIREKTWERBUNG ZU BETREIBEN, SO HABEN SIE DAS RECHT, JEDERZEIT WIDERSPRUCH GEGEN DIE VERARBEITUNG SIE BETREFFENDER PERSONENBEZOGENER DATEN
            ZUM ZWECKE DERARTIGER WERBUNG EINZULEGEN; DIES GILT AUCH F&Uuml;R DAS PROFILING, SOWEIT ES MIT SOLCHER DIREKTWERBUNG IN VERBINDUNG STEHT. WENN SIE WIDERSPRECHEN, WERDEN IHRE PERSONENBEZOGENEN
            DATEN ANSCHLIESSEND NICHT MEHR ZUM ZWECKE DER DIREKTWERBUNG VERWENDET (WIDERSPRUCH NACH ART. 21 ABS. 2 DSGVO).
          </p>
        </div>

        <div>
          <h3>Beschwerde&shy;recht bei der zust&auml;ndigen Aufsichts&shy;beh&ouml;rde</h3>
          <p>
            Im Falle von Verst&ouml;&szlig;en gegen die DSGVO steht den Betroffenen ein Beschwerderecht bei einer Aufsichtsbeh&ouml;rde, insbesondere in dem Mitgliedstaat ihres gew&ouml;hnlichen Aufenthalts,
            ihres Arbeitsplatzes oder des Orts des mutma&szlig;lichen Versto&szlig;es zu. Das Beschwerderecht besteht unbeschadet anderweitiger verwaltungsrechtlicher oder gerichtlicher Rechtsbehelfe.
          </p>
        </div>

        <div>
          <h3>Recht auf Daten&shy;&uuml;bertrag&shy;barkeit</h3>
          <p>
            Sie haben das Recht, Daten, die wir auf Grundlage Ihrer Einwilligung oder in Erf&uuml;llung eines Vertrags automatisiert verarbeiten, an sich oder an einen Dritten in einem g&auml;ngigen,
            maschinenlesbaren Format aush&auml;ndigen zu lassen. Sofern Sie die direkte &Uuml;bertragung der Daten an einen anderen Verantwortlichen verlangen, erfolgt dies nur, soweit es technisch
            machbar ist.
          </p>
        </div>

        <div>
          <h3>SSL- bzw. TLS-Verschl&uuml;sselung</h3>
          <p>
            Diese Seite nutzt aus Sicherheitsgr&uuml;nden und zum Schutz der &Uuml;bertragung vertraulicher Inhalte, wie zum Beispiel Bestellungen oder Anfragen, die Sie an uns als Seitenbetreiber
            senden, eine SSL- bzw. TLS-Verschl&uuml;sselung. Eine verschl&uuml;sselte Verbindung erkennen Sie daran, dass die Adresszeile des Browsers von &bdquo;http://&ldquo; auf &bdquo;https://&ldquo;
            wechselt und an dem Schloss-Symbol in Ihrer Browserzeile.
          </p>
          <p>
            Wenn die SSL- bzw. TLS-Verschl&uuml;sselung aktiviert ist, k&ouml;nnen die Daten, die Sie an uns &uuml;bermitteln, nicht von Dritten mitgelesen werden.
          </p>
        </div>

        <div>
          <h3>Auskunft, L&ouml;schung und Berichtigung</h3>
          <p>
            Sie haben im Rahmen der geltenden gesetzlichen Bestimmungen jederzeit das Recht auf unentgeltliche Auskunft &uuml;ber Ihre gespeicherten personenbezogenen Daten, deren Herkunft und Empf&auml;nger
            und den Zweck der Datenverarbeitung und ggf. ein Recht auf Berichtigung oder L&ouml;schung dieser Daten. Hierzu sowie zu weiteren Fragen zum Thema personenbezogene Daten k&ouml;nnen Sie sich jederzeit
            an uns wenden.
          </p>
        </div>

        <div>
          <h3>Recht auf Einschr&auml;nkung der Verarbeitung</h3>
          <p>
            Sie haben das Recht, die Einschr&auml;nkung der Verarbeitung Ihrer personenbezogenen Daten zu verlangen. Hierzu k&ouml;nnen Sie sich jederzeit an uns wenden. Das Recht auf Einschr&auml;nkung der
            Verarbeitung besteht in folgenden F&auml;llen:
          </p>
          <ul>
            <li>
              Wenn Sie die Richtigkeit Ihrer bei uns gespeicherten personenbezogenen Daten bestreiten, ben&ouml;tigen wir in der Regel Zeit, um dies zu &uuml;berpr&uuml;fen. F&uuml;r die Dauer der
              Pr&uuml;fung haben Sie das Recht, die Einschr&auml;nkung der Verarbeitung Ihrer personenbezogenen Daten zu verlangen.
            </li>
            <li>Wenn die Verarbeitung Ihrer personenbezogenen Daten unrechtm&auml;&szlig;ig geschah/geschieht, k&ouml;nnen Sie statt der L&ouml;schung die Einschr&auml;nkung der Datenverarbeitung verlangen.</li>
            <li>
              Wenn wir Ihre personenbezogenen Daten nicht mehr ben&ouml;tigen, Sie sie jedoch zur Aus&uuml;bung, Verteidigung oder Geltendmachung von Rechtsanspr&uuml;chen ben&ouml;tigen, haben Sie das Recht,
              statt der L&ouml;schung die Einschr&auml;nkung der Verarbeitung Ihrer personenbezogenen Daten zu verlangen.
            </li>
            <li>
              Wenn Sie einen Widerspruch nach Art. 21 Abs. 1 DSGVO eingelegt haben, muss eine Abw&auml;gung zwischen Ihren und unseren Interessen vorgenommen werden. Solange noch nicht feststeht, wessen
              Interessen &uuml;berwiegen, haben Sie das Recht, die Einschr&auml;nkung der Verarbeitung Ihrer personenbezogenen Daten zu verlangen.
            </li>
          </ul>
          <p>
            Wenn Sie die Verarbeitung Ihrer personenbezogenen Daten eingeschr&auml;nkt haben, d&uuml;rfen diese Daten &ndash; von ihrer Speicherung abgesehen &ndash; nur mit Ihrer Einwilligung oder zur
            Geltendmachung, Aus&uuml;bung oder Verteidigung von Rechtsanspr&uuml;chen oder zum Schutz der Rechte einer anderen nat&uuml;rlichen oder juristischen Person oder aus Gr&uuml;nden eines wichtigen
            &ouml;ffentlichen Interesses der Europ&auml;ischen Union oder eines Mitgliedstaats verarbeitet werden.
          </p>
        </div>
      </div>

      <div class="paragraph">
        <h2>4. Datenerfassung auf dieser Website</h2>
        <div>
          <h3>Cookies</h3>
          <p>
            Unsere Internetseiten verwenden so genannte &bdquo;Cookies&ldquo;. Cookies sind kleine Textdateien und richten auf Ihrem Endger&auml;t keinen Schaden an. Sie werden entweder vor&uuml;bergehend
            f&uuml;r die Dauer einer Sitzung (Session-Cookies) oder dauerhaft (permanente Cookies) auf Ihrem Endger&auml;t gespeichert. Session-Cookies werden nach Ende Ihres Besuchs automatisch gel&ouml;scht.
            Permanente Cookies bleiben auf Ihrem Endger&auml;t gespeichert, bis Sie diese selbst l&ouml;schen&nbsp;oder eine automatische L&ouml;schung durch Ihren Webbrowser erfolgt.
          </p>
          <p>
            Teilweise k&ouml;nnen auch Cookies von Drittunternehmen auf Ihrem Endger&auml;t gespeichert werden, wenn Sie unsere Seite betreten (Third-Party-Cookies). Diese erm&ouml;glichen uns oder
            Ihnen die Nutzung bestimmter Dienstleistungen des Drittunternehmens (z.&nbsp;B. Cookies zur Abwicklung von Zahlungsdienstleistungen).
          </p>
          <p>
            Cookies haben verschiedene Funktionen. Zahlreiche Cookies sind technisch notwendig, da bestimmte Websitefunktionen ohne diese nicht funktionieren w&uuml;rden (z.&nbsp;B. die Warenkorbfunktion
            oder die Anzeige von Videos). Andere Cookies dienen dazu, das Nutzerverhalten auszuwerten&nbsp;oder Werbung anzuzeigen.
          </p>
          <p>
            Cookies, die zur Durchf&uuml;hrung des elektronischen Kommunikationsvorgangs (notwendige Cookies) oder zur Bereitstellung bestimmter, von Ihnen erw&uuml;nschter Funktionen (funktionale Cookies,
            z.&nbsp;B. f&uuml;r die Warenkorbfunktion) oder zur Optimierung der Website (z.&nbsp;B. Cookies zur Messung des Webpublikums) erforderlich sind, werden auf Grundlage von Art. 6 Abs. 1 lit. f DSGVO
            gespeichert, sofern keine andere Rechtsgrundlage angegeben wird. Der Websitebetreiber hat ein berechtigtes Interesse an der Speicherung von Cookies zur technisch fehlerfreien und optimierten Bereitstellung
            seiner Dienste. Sofern eine Einwilligung zur Speicherung von Cookies abgefragt wurde, erfolgt die Speicherung der betreffenden Cookies ausschlie&szlig;lich auf Grundlage dieser Einwilligung
            (Art. 6 Abs. 1 lit. a DSGVO); die Einwilligung ist jederzeit widerrufbar.
          </p>
          <p>
            Sie k&ouml;nnen Ihren Browser so einstellen, dass Sie &uuml;ber das Setzen von Cookies informiert werden und Cookies nur im Einzelfall erlauben, die Annahme von Cookies f&uuml;r bestimmte
            F&auml;lle oder generell ausschlie&szlig;en sowie das automatische L&ouml;schen der Cookies beim Schlie&szlig;en des Browsers aktivieren. Bei der Deaktivierung von Cookies kann die Funktionalit&auml;t
            dieser Website eingeschr&auml;nkt sein.
          </p>
          <p>
            Soweit Cookies von Drittunternehmen oder zu Analysezwecken eingesetzt werden, werden wir Sie hier&uuml;ber im Rahmen dieser Datenschutzerkl&auml;rung gesondert
            informieren und ggf. eine Einwilligung abfragen.
          </p>
        </div>

        <div>
          <h3>Anfrage per E-Mail, Telefon oder Telefax</h3>
          <p>
            Wenn Sie uns per E-Mail, Telefon oder Telefax kontaktieren, wird Ihre Anfrage inklusive aller daraus hervorgehenden personenbezogenen Daten (Name, Anfrage) zum Zwecke der Bearbeitung Ihres Anliegens bei uns
            gespeichert und verarbeitet. Diese Daten geben wir nicht ohne Ihre Einwilligung weiter.
          </p>
          <p>
            Die Verarbeitung dieser Daten erfolgt auf Grundlage von Art. 6 Abs. 1 lit. b DSGVO, sofern Ihre Anfrage mit der Erf&uuml;llung eines Vertrags zusammenh&auml;ngt oder zur Durchf&uuml;hrung vorvertraglicher
            Ma&szlig;nahmen erforderlich ist. In allen &uuml;brigen F&auml;llen beruht die Verarbeitung auf unserem berechtigten Interesse an der effektiven Bearbeitung der an uns gerichteten Anfragen
            (Art. 6 Abs. 1 lit. f DSGVO) oder auf Ihrer Einwilligung (Art. 6 Abs. 1 lit. a DSGVO) sofern diese abgefragt wurde.
          </p>
          <p>
            Die von Ihnen an uns per Kontaktanfragen &uuml;bersandten Daten verbleiben bei uns, bis Sie uns zur L&ouml;schung auffordern, Ihre Einwilligung zur Speicherung widerrufen oder der Zweck
            f&uuml;r die Datenspeicherung entf&auml;llt (z.&nbsp;B. nach abgeschlossener Bearbeitung Ihres Anliegens). Zwingende gesetzliche Bestimmungen &ndash; insbesondere gesetzliche Aufbewahrungsfristen
            &ndash; bleiben unber&uuml;hrt.
          </p>
        </div>
      </div>

      <div class="paragraph">
        <h2>5. Plugins und Tools</h2>
        <div>
          <h3>Google Web Fonts</h3>
          <p>
            Diese Seite nutzt zur einheitlichen Darstellung von Schriftarten so genannte Web Fonts, die von Google bereitgestellt werden. Beim Aufruf einer Seite l&auml;dt Ihr Browser die ben&ouml;tigten
            Web Fonts in ihren Browsercache, um Texte und Schriftarten korrekt anzuzeigen.
          </p>
          <p>
            Zu diesem Zweck muss der von Ihnen verwendete Browser Verbindung zu den Servern von Google aufnehmen. Hierdurch erlangt Google Kenntnis dar&uuml;ber, dass &uuml;ber Ihre IP-Adresse diese
            Website aufgerufen wurde. Die Nutzung von Google WebFonts erfolgt auf Grundlage von Art. 6 Abs. 1 lit. f DSGVO. Der Websitebetreiber hat ein berechtigtes Interesse an der einheitlichen Darstellung des Schriftbildes
            auf seiner Website. Sofern eine entsprechende Einwilligung abgefragt wurde (z.&nbsp;B. eine Einwilligung zur Speicherung von Cookies), erfolgt die Verarbeitung ausschlie&szlig;lich auf Grundlage von Art. 6 Abs. 1 lit. a DSGVO;
            die Einwilligung ist jederzeit widerrufbar.
          </p>
          <p>Wenn Ihr Browser Web Fonts nicht unterst&uuml;tzt, wird eine Standardschrift von Ihrem Computer genutzt.</p>
          <p>Weitere Informationen zu Google Web Fonts finden Sie unter
            <a href="https://developers.google.com/fonts/faq" target="_blank" rel="noopener noreferrer">https://developers.google.com/fonts/faq</a>
            und in der Datenschutzerkl&auml;rung von Google:
            <a href="https://policies.google.com/privacy?hl=de" target="_blank" rel="noopener noreferrer">https://policies.google.com/privacy?hl=de</a>.
          </p>
          <p>Quelle: <a href="https://www.e-recht24.de">https://www.e-recht24.de</a></p>
        </div>
        <div>
          <h3>Google Analytics</h3>
          <p>Wir verwenden Google Analytics, um die Website-Nutzung zu analysieren. Die daraus gewonnenen Daten werden genutzt, um unsere Website zu optimieren.&nbsp;</p>
          <p>
            Google Analytics ist ein Webanalysedienst, der von <em>Google Inc.</em> (1600 Amphitheatre Parkway, Mountain View, CA 94043, United States) betrieben und bereitgestellt wird.
            Google verarbeitet die Daten zur Website-Nutzung in unserem Auftrag und verpflichtet sich vertraglich zu Maßnahmen, um die Vertraulichkeit der verarbeiteten Daten zu gewährleisten.
          </p>
          <p>Während Ihres Website-Besuchs werden u.a. folgende Daten aufgezeichnet:</p>
          <ul>
            <li>Aufgerufene Seiten</li>
            <li>Ihr Verhalten auf den Seiten (beispielsweise Klicks, Scroll-Verhalten und Verweildauer)</li>
            <li>Ihr ungefährer Standort (Land und Stadt)</li>
            <li>Ihre anonymisierte IP-Adresse (in gekürzter Form, sodass keine eindeutige Zuordnung möglich ist)</li>
            <li>Technische Informationen wie Browser, Internetanbieter, Endgerät und Bildschirmauflösung</li>
            <li>Herkunftsquelle Ihres Besuchs (d.h. über welche Website bzw. über welches Werbemittel Sie zu uns gekommen sind)</li>
          </ul>

          <p>Diese Daten werden an einen Server von Google in den USA übertragen.&nbsp;</p>
          <p>
            Google Analytics speichert Cookies in Ihrem Webbrowser für die Dauer von zwei&nbsp;Jahren seit Ihrem letzten Besuch. Diese Cookies enthalten eine zufallsgenerierte User-ID, mit der
            Sie bei zukünftigen Website-Besuchen wiedererkannt werden können.
          </p>
          <p>
            Die aufgezeichneten Daten werden zusammen mit der zufallsgenerierten User-ID gespeichert, was die Auswertung pseudonymer Nutzerprofile ermöglicht. Diese nutzerbezogenen Daten werden
            automatisch nach 2 Monaten gelöscht. Sonstige Daten bleiben in aggregierter Form unbefristet gespeichert.
          </p>
          <p>
            Sollten Sie mit der Erfassung nicht einverstanden sein, können Sie diese mit der einmaligen Installation des
            <a href="https://tools.google.com/dlpage/gaoptout?hl=de">Browser-Add-ons zur Deaktivierung von Google Analytics</a> unterbinden oder
            durch das Ablehnen der Cookies über unseren Cookie Einstellungs Dialog.
          </p>
          <p>Folgende Cookies werden von Google Analytics verwendet:</p>
          <ul>
            <li>
              _ga_#
              <p>Geltungsbereich: Ihre Domain (1st Party)</p>
              <p>Zweck: Enthält eine zufallsgenerierte User-ID. Anhand dieser ID kann Google Analytics wiederkehrende User auf dieser Website wiedererkennen und die Daten von früheren Besuchen zusammenführen.</p>
              <p>Speicherdauer: 2 Jahre</p>
            </li>
            <li>
              _ga
              <p>Geltungsbereich: Ihre Domain (1st Party)</p>
              <p>Zweck: Enthält eine zufallsgenerierte User-ID. Anhand dieser ID kann Google Analytics wiederkehrende User auf dieser Website wiedererkennen und die Daten von früheren Besuchen zusammenführen.</p>
              <p>Speicherdauer: 2 Jahre</p>
            </li>
          </ul>
          <p><em>Quelle: <a href="https://traffic3.net/">traffic3.net</a></em></p>
        </div>
        <div>
          <h3>Cookiebot</h3>
          Betroffene: Website Besucher<br />
          Zweck: Einholung der Zustimmung zu bestimmten Cookies und somit dem Einsatz bestimmter Tools<br />
          Verarbeitete Daten:  Daten zur Verwaltung der eingestellten Cookie-Einstellungen wie IP-Adresse, Zeitpunkt der Zustimmung, Art der Zustimmung, einzelne Zustimmungen. Mehr Details dazu finden Sie beim jeweils eingesetzten Tool.<br />
          Speicherdauer: die Daten werden nach einem Jahr gelöscht<br />
          Rechtsgrundlagen: Art. 6 Abs. 1 lit. a DSGVO (Einwilligung), Art. 6 Abs. 1 lit.f DSGVO (berechtigte Interessen)
        </div>
        <div>
          <h3>Was ist Cookiebot?</h3>
          <p>Wir verwenden auf unserer Website Funktionen des Anbieters Cookiebot. Hinter Cookiebot steht das Unternehmen Cybot A/S, Havnegade 39, 1058 Kopenhagen, DK. Cookiebot bietet uns unter anderem die Möglichkeit, Ihnen einen umfangreichen Cookie-Hinweis (auch Cookie-Banner oder Cookie-Notice genannt) zu liefern. Durch die Verwendung dieser Funktion können Daten von Ihnen an Cookiebot bzw. Cybot gesendet, gespeichert und verarbeitet werden. In dieser Datenschutzerklärung informieren wir Sie warum wir Cookiebot nutzen, welche Daten übertragen werden und wie Sie diese Datenübertragung verhindern können.</p>
          <p>Cookiebot ist ein Software-Produkt des Unternehmens Cybot. Die Software erstellt automatisch einen DSGVO-konformen Cookie-Hinweis für unserer Websitebesucher. Zudem scannt, kontrolliert und wertet die Technologie hinter Cookiebot alle Cookies und Tracking-Maßnahmen auf unserer Website.</p>
          <div>
            <h3>Warum verwenden wir Cookiebot auf unserer Website?</h3>
            <p>Datenschutz nehmen wir sehr ernst. Wir wollen Ihnen ganz genau zeigen, was auf unserer Website vor sich geht und welche Ihrer Daten gespeichert werden. Cookiebot hilft uns einen guten Überblick über all unsere Cookies (Erst- und Drittanbieter-Cookies) zu erhalten. So können wir Sie über die Nutzung von Cookies auf unserer Website exakt und transparent informieren. Sie bekommen stets einen aktuellen und datenschutzkonformen Cookie-Hinweis und entscheiden selbst, welche Cookies Sie zulassen und welche nicht.</p>
          </div>
          <div>
            <h3>Welche Daten werden von Cookiebot gespeichert?</h3>
            <p>Wenn Sie Cookies zulassen, werden folgende Daten an Cybot übertragen, gespeichert und verarbeitet.</p>
            <ul>
              <li>IP-Adresse (in anonymisierter Form, die letzten 3 Ziffern werden auf 0 gesetzt)</li>
              <li>Datum und Uhrzeit Ihres Einverständnisses</li>
              <li>unsere Website-URL</li>
              <li>technische Browserdaten</li>
              <li>verschlüsselter, anonymer Key</li>
              <li>die Cookies, die Sie zugelassen haben (als Zustimmungsnachweis)</li>
            </ul>
            <p>Folgende Cookies werden von Cookiebot gesetzt, wenn Sie der Verwendung von Cookies zugestimmt haben:</p>
            <p>
              <strong>Name:</strong> CookieConsent<br />
              <strong>Wert:</strong> {stamp:&#8217;P7to4eNgIHvJvDerjKneBsmJQd9311895308-2<br />
              <strong>Verwendungszweck:</strong> In diesem Cookie wird Ihr Zustimmungsstatus, gespeichert. Dadurch kann unsere Website auch bei zukünftigen Besuchen den aktuellen Status lesen und befolgen.<br />
              <strong>Ablaufdatum:</strong> nach einem Jahr
            </p>
            <p>
              <strong>Name:</strong> CookieConsentBulkTicket<br />
              <strong>Wert:</strong> kDSPWpA%2fjhljZKClPqsncfR8SveTnNWhys5NojaxdFYBPjZ2PaDnUw%3d%3311895308-6<br />
              <strong>Verwendungszweck:</strong> Dieses Cookie wird gesetzt, wenn Sie alle Cookies erlauben und somit eine &#8220;Sammelzustimmung&#8221; aktiviert haben. Das Cookie speichert dann eine eigene, zufällige und eindeutige ID.<br />
              <strong>Ablaufdatum: </strong>nach einem Jahr
            </p>
            <p>
              <strong>Name:</strong> _abck<br />
              <strong>Wert:</strong> DA365EC9CD1866BD195632D505CA6D0C~21QQyocU/0HSrmpVzVzoNNHU+XackLuiAKp6kmFzsd5Xc+35eNu3iyapLXcmwMCTR+621W1OImZkn4w/lszcbbw3Iiavmj304rMGnQWVr0r/r52bNvgOyz81wg85LeRJym7p89hW4QgRwdvxE2YFJZpNZA1zOmK1aY2LKaHIzNs=<br />
              <strong>Verwendungszweck:</strong> Wird verwendet, um Replay-Cookie-Angriffe zu erkennen und abzuwehren – Das Cookie ist für die Sicherheit und Integrität der Website erforderlich.<br />
              <strong>Ablaufdatum: </strong>nach einem Jahr
            </p>
            <p>
              <strong>Name:</strong> bm_sv<br />
              <strong>Wert:</strong> C5D97903D3B2B8E09D98C38C9445EB7C~0~YAAQB9R7XE9afEh9AQAAKYH5kQdxFUSqWKabJG5n4VSabx3aGU51Yhp2swydWTv3T/bPjQNnrIc04G0qIuyBtDw2Vr4nGqJFRMPQCQ9vqLA7TZdcXtncrVVUC+x0Iriamc6imB37zWbmROhbUTHs1avGmOCCDP3i8+7GNvB9TS8/E1xkMGVhGZBE13dF6sPfTEUnAmvq7nuymr+Dx9BTtwSo50ebC5E3nzdmx4WIVvFeXFqJAFgjb9N+hSnDx54h6IuVg/B6mUMZ1FKAc=~-1~-1~-1<br />
              <strong>Verwendungszweck:</strong> Dieses Cookie wird verwendet, um zwischen Menschen und Bots zu unterscheiden. Dies ist für die Website von Vorteil, um valide Berichte über die Nutzung ihrer Website zu erstellen. <br />
              <strong>Ablaufdatum: </strong>nach einem Tag
            </p>
            <p>
              Laut der Datenschutzerklärung von Cybot verkauft das Unternehmen personenbezogene Daten nicht weiter. Cybot gibt allerdings Daten an vertrauensvolle Dritt- oder Subunternehmen weiter,
              die dem Unternehmen helfen, die eigenen betriebswirtschaftlichen Ziele zu erreichen. Daten werden auch dann weitergegeben, wenn dies rechtlich erforderlich ist.
            </p>
          </div>
          <div>
            <h3>Wie lange und wo werden die Daten gespeichert?</h3>
            <p>
              Alle erhobenen Daten werden ausschließlich innerhalb der Europäischen Union übertragen, gespeichert und weitergeleitet. Die Daten werden in einem Azure-Rechenzentrum
              (Cloud-Anbieter ist Microsoft) gespeichert. Auf 
              <a class="adsimple-311895308" href="https://azure.microsoft.com/de-de/global-infrastructure/regions/?tid=311895308" target="_blank" rel="noopener noreferrer">https://azure.microsoft.com/de-de/global-infrastructure/regions/</a>
              erfahren Sie mehr über alle „Azure-Regionen“. Alle User Daten werden von Cookiebot nach 12 Monaten ab der Registrierung (Cookie-Zustimmung) bzw. unmittelbar nach Kündigung des Cookiebot-Services gelöscht.
            </p>
          </div>
          <div>
            <h3>Wie kann ich meine Daten löschen bzw. die Datenspeicherung verhindern?</h3>
            <p>
              Sie haben jederzeit das Recht auf Ihre personenbezogenen Daten zuzugreifen und sie auch zu löschen. Die Datenerfassung und Speicherung können Sie beispielsweise verhindern, indem Sie über den Cookie-Hinweis
              die Verwendung von Cookies ablehnen. Eine weitere Möglichkeit die Datenverarbeitung zu unterbinden bzw. nach Ihren Wünschen zu verwalten, bietet Ihr Browser. Je nach Browser funktioniert die
              Cookie-Verwaltung etwas anders. Hier finden Sie die Anleitungen zu den momentan bekanntesten Browsern:
            </p>
            <p>
              <a href="https://support.google.com/chrome/answer/95647?tid=311895308" target="_blank" rel="noopener noreferrer">Chrome: Cookies in Chrome löschen, aktivieren und verwalten</a>
            </p>
            <p>
              <a href="https://support.apple.com/de-at/guide/safari/sfri11471/mac?tid=311895308" target="_blank" rel="noopener noreferrer">Safari: Verwalten von Cookies und Websitedaten mit Safari</a>
            </p>
            <p>
              <a href="https://support.mozilla.org/de/kb/cookies-und-website-daten-in-firefox-loschen?tid=311895308" target="_blank" rel="noopener noreferrer">Firefox: Cookies löschen, um Daten zu entfernen, die Websites auf Ihrem Computer abgelegt haben</a>
            </p>
            <p>
              <a href="https://support.microsoft.com/de-at/help/17442/windows-internet-explorer-delete-manage-cookies?tid=311895308" target="_blank" rel="noopener noreferrer">Internet Explorer: Löschen und Verwalten von Cookies</a>
            </p>
            <p>
              <a href="https://support.microsoft.com/de-at/help/4027947/windows-delete-cookies?tid=311895308" target="_blank" rel="noopener noreferrer">Microsoft Edge: Löschen und Verwalten von Cookies</a>
            </p>
          </div>
          <div>
            <h3>Rechtsgrundlage</h3>
            <p>
              Wenn Sie Cookies zustimmen, werden über diese Cookies personenbezogene Daten von Ihnen verarbeitet und gespeichert. Falls wir durch Ihre <strong>Einwilligung</strong> (Artikel 6 Abs. 1 lit. a DSGVO) Cookies verwenden dürfen,
              ist diese Einwilligung auch gleichzeitig die Rechtsgrundlage für die Verwendung von Cookies bzw. die Verarbeitung Ihrer Daten. Um die Einwilligung zu Cookies verwalten zu können und Ihnen die Einwilligung ermöglichen zu können,
              kommt der Cookiebot zum Einsatz. Der Einsatz dieser Software ermöglicht uns, die Website auf effiziente Weise rechtskonform zu betreiben, was ein <strong>berechtigtes Interesse</strong> (Artikel 6 Abs. 1 lit. f DSGVO) darstellt.
            </p>
            <p>Wenn Sie mehr über die Datenschutzrichtlinien von „Cookiebot“ bzw. dem dahinterstehenden Unternehmen Cybot erfahren wollen, empfehlen wir Ihnen die Datenschutzrichtlinien unter <a class="adsimple-311895308" href="https://www.cookiebot.com/de/privacy-policy/?tid=311895308" target="_blank" rel="noopener noreferrer">https://www.cookiebot.com/de/privacy-policy/</a> durchzulesen.</p>
            <p>&nbsp;</p>
            <p>Alle Texte sind urheberrechtlich geschützt.</p>
            <p>Quelle: Erstellt mit dem <a href="https://www.adsimple.de/datenschutz-generator/" title="Datenschutz Generator von AdSimple für Deutschland">Datenschutz Generator</a> von AdSimple</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "PrivacyPolicy"
}
</script>
